import { middleware } from './middleware';

export default [middleware];
